import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@mui/material';

import {
  ROLE_SITE_FINANCIAL_COORDINATOR,
  ROLE_SYSTEM_ADMINISTRATOR,
  ROLE_TRAVEL_COORDINATOR
} from '../../../../../../../constants/userRoles';
import { userHasRole } from '../../../../../../../services/auth';
import { NSC_REIMBURSEMENT, NSPP_REIMBURSEMENT } from '../../../../../../../services/i18n/namespaces';
import {
  RBS_APPROVED,
  RBS_CANCELED,
  RBS_DENIED,
  RBS_DRAFT,
  reimbursementStatuses
} from '../../EncountersSection/PaymentsSection/reimbursementConstants';

export default function StatusDropdown({ changeStatus, status, totalAmount, canBeApprovedOrDenied }) {
  const { t } = useTranslation();
  const allowedStatuses = useMemo(
    function() {
      return reimbursementStatuses.map(function(value) {
        return prepareStatus({ ...value });
      });
      function prepareStatus(value) {
        if (
          !userHasRole([ROLE_SYSTEM_ADMINISTRATOR, ROLE_SITE_FINANCIAL_COORDINATOR, ROLE_TRAVEL_COORDINATOR]) &&
          [RBS_APPROVED, RBS_DENIED].includes(value.id)
        ) {
          value.disabled = true;
        }
        if (status === RBS_APPROVED) {
          value.disabled = true;
        }
        if (status === RBS_CANCELED && value.id !== RBS_DRAFT) {
          value.disabled = true;
        }
        if ((value.id === RBS_APPROVED || value.id === RBS_DENIED) && (!canBeApprovedOrDenied || totalAmount === 0)) {
          value.disabled = true;
        }
        return value;
      }
    },
    [status, canBeApprovedOrDenied, totalAmount]
  );

  if (!status) return null;
  return (
    <TextField
      value={status}
      onChange={function({ target }) {
        changeStatus(target.value);
      }}
      select
      label={t(`${NSPP_REIMBURSEMENT}:table.status`)}
      variant="standard"
      sx={{ width: 200 }}
      size="small"
    >
      {allowedStatuses.map(e => (
        <MenuItem key={e.id} value={e.id} disabled={e.disabled}>
          {t(`${NSC_REIMBURSEMENT}:statuses.${e.name}`)}
        </MenuItem>
      ))}
    </TextField>
  );
}
